<template>
  <div class="border">
    <div class="header capitalize-all">{{ title }}</div>
    <div class="menu">
      <span class="drowpdown-label capitalize-all">{{ optionA.selected }}</span>
      <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
        <template #button-content>
          <b-icon-chevron-down class="icon"></b-icon-chevron-down>
        </template>
        <template v-for="item of optionA.options">
          <b-dropdown-item-button
            :key="item"
            v-if="optionA.selected !== item"
            @click="setOptionA(item)"
            >{{ item }}</b-dropdown-item-button
          >
        </template>
      </b-dropdown>
      <span class="drowpdown-label capitalize-all">EUR</span>
      <b-dropdown size="lg" variant="link" toggle-class="text-decoration-none" no-caret>
        <template #button-content>
          <b-icon-chevron-down class="icon"></b-icon-chevron-down>
        </template>
        <b-dropdown-item href="#">EUR</b-dropdown-item>
      </b-dropdown>
    </div>

    <div class="row container">
      <d3pie :data.sync="data"></d3pie>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

import VueApexCharts from "vue-apexcharts";
import RadialBar from "@/components/common/widgets/RadialBar.vue";
import Pie from "@/components/common/widgets/Pie.vue";
import D3pie from "@/components/common/widgets/PieD3.vue";
import { EventBus } from "@/event-bus";

Vue.use(VueApexCharts);

Vue.component("apexchart", VueApexCharts);
@Component({
  components: { D3pie, Pie, RadialBar },
})
export default class DenominacionesConExcedentes extends Vue {
  @Prop({ required: false, default: "denominaciones con excedentes" })
  title!: string;
  optionA: { selected: string; options: string[] } = {
    selected: "BILLETES",
    options: ["BILLETES", "MONEDAS"],
  };

  data = [
    { name: "P100", value: 8123674.87 },
    { name: "P500", value: 10536298.39 },
    { name: "P200", value: 4630000.24 },
    { name: "P20", value: 5839665.03 },
    { name: "P50", value: 6746453.84 },
  ];

  setOptionA(item: string): void {
    this.optionA.selected = item;
    if (item == "MONEDAS") {
      this.data = [
        { name: "M0.01", value: 8123674.87 },
        { name: "M0.02", value: 10536298.39 },
        { name: "M0.05", value: 4630000.24 },
        { name: "M0.1", value: 5839665.03 },
        { name: "M0.2", value: 6746453.84 },
        { name: "M0.3", value: 6746453.84 },
        { name: "M0.5", value: 6746453.84 },
        { name: "M1", value: 6746453.84 },
        { name: "M2", value: 6746453.84 },
      ];
    } else {
      this.data = [
        { name: "P100", value: 8123674.87 },
        { name: "P500", value: 10536298.39 },
        { name: "P200", value: 4630000.24 },
        { name: "P20", value: 5839665.03 },
        { name: "P50", value: 6746453.84 },
      ];
    }
    EventBus.$emit("update-chart", this.data);
  }
}
</script>

<style lang="scss" scoped>
.demandas {
  padding-left: 20px;
}

.menu {
  margin-bottom: 10px;
}

.detail-label {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: var(--secundario-prosegur-oscuro);
  margin-left: -15px;
  margin-right: -15px;
}

.detail-amount {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: var(--secundario-prosegur-oscuro);
  margin-left: -20px;
  margin-right: -15px;
}

.detail-container {
  padding-top: 1rem;
}

.icon {
  width: 14px;
  color: var(--secundario-prosegur-oscuro);
  z-index: 2;
}

.drowpdown-label {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.23;
  letter-spacing: normal;
  text-align: center;
  color: #808080;
}

.capitalize-all {
  text-transform: uppercase;
}

.header {
  margin: 0 0 10px 0;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 14px;
  font-weight: bold;
  color: #9b9b9b;
  padding-top: 0.5rem;
}

.border {
  margin-left: 1.5rem;
  margin-right: 1.5rem;
  margin-bottom: 2rem;

  border-radius: 6px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
  padding: 0.5rem 0 0 1rem;
  min-width: 357px;
}

.date {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: bold;
  color: var(--amarillo-prosegur);
  padding-left: 0.5rem;
}

.data-header {
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #9b9b9b;
}

.data-body {
  width: 130px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  color: #4a4a4a;
}

.row-data {
  position: relative;
  padding-bottom: 1rem;
}

.date-container {
  padding-left: 3rem;
  margin-right: 1rem;
  padding-top: 0.1rem;
}

.vertical-line {
  border-left: solid 1px #e8e8e8;
  padding-right: 0.5rem;
}

.horizontal-line {
  border-top: solid 1px #e8e8e8;
  padding-right: 1rem;
  width: 90%;
  padding-bottom: 1rem;
}

.hour {
  width: 54px;
  font-size: 12px;
  font-weight: bold;
  padding-left: 0.5rem;
  color: #979797;
}

.icon-white {
  width: 11px;
  color: white;
  z-index: 3;
  position: absolute;
  padding-left: 3px;
}

.moneda {
  width: 35px;
  height: 21px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}

.total {
  width: 116px;
  height: 24px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #4a4a4a;
}

.total-billete {
  width: 68px;
  height: 14px;
  margin: 6px 10px 19px 7px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #808080;
}

.total-monedas {
  width: 68px;
  height: 14px;
  margin: 6px 10px 19px 7px;
  font-family: Roboto, Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #808080;
}

.sumatorio {
  padding-left: 1rem;
}

.total-desglosado {
  padding-left: 1rem;
}
</style>
